if (!customElements.get('br-recipes-video')) {
  customElements.define(
    'br-recipes-video',
    class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        const button = this.querySelector('button');
        const template = this.querySelector('template');
        if (!button || !template) return;

        this.initialized = true;
        button.addEventListener(
          'click',
          () => {
            if (this.querySelector('video, iframe')) return;
            this.append(template.content.cloneNode(true));
            button.hidden = true;
            const player = this.querySelector('video, iframe');
            player?.focus();
            if (player?.tagName === 'VIDEO') {
              player.play().catch(() => {
                /* Native controls remain available when autoplay is blocked. */
              });
            }
          },
          { once: true }
        );
      }

      disconnectedCallback() {
        this.querySelector('video')?.pause();
      }
    }
  );
}
